import React, { Component } from 'react';

import { ApiHelper } from '../../../common/helpers/ApiHelper';
import { AppHelper } from '../../../helpers/AppHelper';
import { Helper } from '../../../common/helpers/Helper';
import { BaseEntityPage } from '../../../common/components/BaseEntityPage';
import { AppConfig } from '../../../AppConfig';
import { AppStyles, AppTheme } from '../../../styles/AppTheme';
import { Controller } from '../../../common/Controller';

import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import { css, StyleSheet } from 'aphrodite';
import { UiHelper } from '../../helpers/UiHelper';

export class ProductsByTag extends BaseEntityPage {

  constructor(props) {
    super(props)
    this.orgId = this.props.match.params.orgId
    this.tagId = this.props.match.params.id
    this.pageTitle = Helper.getString('products')
    this.noAdd = true
    this.breadCrumbs = [
      { title: Helper.getString('home'), to: '/admin/orgs/' + this.orgId },
      { title: Helper.getString('lists'), to: '/admin/orgs/' + this.orgId + '/tags' },
      { title: this.pageTitle },
    ]
    this.toFetch = [
      { method: 'GET', paths: ['products'], queryParams: {orgId: this.orgId, tagId: this.tagId, limit: 200 } },
    ]
    this.tableHeadersMap = {
      Index: (current) => { return current.__index + 1 },
      'Slug / ID': (current) => {
        return (
          <div>
            <span className={css(Styles.spanValue)}>{current.slug}</span>
            <br />
            <span className={css(Styles.spanValue)}>{current.id}</span>
          </div>
        )
      },
      Title: (current) => current.title,
    }
    this.tableHeaders = Object.keys(this.tableHeadersMap)
    this.apiData = {
    }
  }

  onFetchSuccess(results, options) {
    const { fetchNext } = options || {}
    this.handleNextpage(results[0])
    this.setState({
      items: Helper.sortDictArray(fetchNext ? this.state.items.concat(results[0].items) : results[0].items),
      item: this.state.item || results[1]
    })
    this.pageTitle = this.state.item.title
  }

  onTableValue(current, index) {
    if (!this.tableHeaders[index]) {
      return ''
    }
    return this.tableHeadersMap[this.tableHeaders[index]](current)
  }

  onActions = (current) => {
    const actions = []
    actions.push(UiHelper.buttonOpenProduct(this, current))
    return actions
  }
}

const Styles = StyleSheet.create({
  spanValue: {
    fontSize: 12
  }
})